/**
 * Where sam-dbam lives.
 *
 * Set REACT_APP_DBAM_BASE at build time. The fallbacks derive it from this
 * page's own address so a preview deployment still works without anyone having
 * to configure it.
 *
 * This lives in its own file rather than in AuthContext, where it used to be,
 * because the idle clock needs it too. AuthContext imports the idle clock, so
 * the clock cannot import AuthContext back — that is a cycle, and the module
 * that loses the race gets an undefined function at call time.
 *
 * AuthContext still re-exports it. Several modules and their tests import it
 * from there, and moving the name as well as the code would have broken them
 * for no benefit.
 */
export function getDbamBase() {
    const envBase = (typeof process !== 'undefined' && process.env?.REACT_APP_DBAM_BASE) || '';
    if (envBase) return envBase.replace(/\/+$/, '');

    const origin = (typeof window !== 'undefined' && window.location && window.location.origin) || '';
    if (origin.includes('channels.samsurveyor.com')) {
        return origin.replace('channels.samsurveyor.com', 'api.samsurveyor.com');
    }
    if (origin.includes('cloudsam-channels')) {
        return origin.replace('cloudsam-channels', 'sam-dbam');
    }
    return 'http://localhost:8080';
}

export default getDbamBase;
